// extracted by mini-css-extract-plugin
module.exports = {"memoria":"memoria_memoria__CPwI7","any":"memoria_any__fiLha"};